export const HOME_PAGE_LOADED = 'HOME_PAGE_LOADED';

export const homePageLoaded = () => ({
  type: HOME_PAGE_LOADED
});



/** WEBPACK FOOTER **
 ** ./app/store/home/home.js
 **/